(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kl-alien-size-guide"] && !Shopify.designMode) return;
  try {
    function formatInches(value) {
    return value
      .trim()
      .split(/\s*[-–]\s*/)
      .map((part) => {
        const number = Number.parseFloat(part);
        if (Number.isNaN(number)) return part;
        return (number / 2.54).toFixed(1).replace(/\.0$/, '');
      })
      .join('–');
  }

  function setSizeGuideUnit(guide, unit) {
    guide.querySelectorAll('[data-size-guide-unit]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.sizeGuideUnit === unit));
    });

    guide.querySelectorAll('[data-cm]').forEach((cell) => {
      const measurement = cell.querySelector('[data-size-guide-measurement]');
      measurement.textContent = unit === 'in' ? formatInches(cell.dataset.cm) : cell.dataset.cm;
    });
  }

  document.querySelectorAll('[data-kl-size-guide]').forEach((guide) => {
    if (guide.dataset.initialized === 'true') return;
    guide.dataset.initialized = 'true';

    guide.querySelectorAll('[data-size-guide-unit]').forEach((button) => {
      button.addEventListener('click', () => setSizeGuideUnit(guide, button.dataset.sizeGuideUnit));
    });

    setSizeGuideUnit(guide, guide.dataset.defaultUnit || 'cm');
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kl-region-dialog"] && !Shopify.designMode) return;
  try {
    (()=>{
    const dialog=document.getElementById('kl-region-dialog');
    if(!dialog||dialog.dataset.ready)return;
    dialog.dataset.ready='true';
    const picker=dialog.querySelector('details');
    const search=dialog.querySelector('input[type=search]');
    const rows=[...dialog.querySelectorAll('.kl-region-countries li')];
    const normalize=value=>value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
    const languageInput=dialog.querySelector('[name=language_code]');
    const supported=languageInput.dataset.supportedLanguages.split(',');
    // Published locales only. Unmapped destinations use English.
    const countryLanguages={FR:'fr',MC:'fr',BE:'fr',LU:'fr',GF:'fr',GP:'fr',MQ:'fr',RE:'fr',YT:'fr',PF:'fr',NC:'fr',BL:'fr',MF:'fr',PM:'fr',WF:'fr',DE:'de',AT:'de',LI:'de',CH:'de',ES:'es',MX:'es',AR:'es',BO:'es',CL:'es',CO:'es',CR:'es',CU:'es',DO:'es',EC:'es',SV:'es',GT:'es',HN:'es',NI:'es',PA:'es',PY:'es',PE:'es',PR:'es',UY:'es',VE:'es',IT:'it',SM:'it',VA:'it',CZ:'cs',RU:'ru',BR:'pt-BR'};
    const languageFor=country=>{const preferred=countryLanguages[country]||'en';return supported.find(code=>code.toLowerCase()===preferred.toLowerCase())||supported.find(code=>code==='en')||languageInput.defaultValue;};
    dialog.querySelector('form').addEventListener('submit',()=>{languageInput.value=languageFor(dialog.querySelector('[name=country_code]').value);});
    const showCountry=button=>{
      dialog.querySelector('#kl-region-current').textContent=button.dataset.label;
      const flag=dialog.querySelector('.kl-region-selected-flag');
      flag.removeAttribute('srcset');
      flag.src=button.querySelector('.kl-region-flag').getAttribute('src');
    };
    let opener;
    document.addEventListener('click',event=>{
      const button=event.target.closest('[data-kl-region-open]');
      if(!button)return;
      opener=button;
      dialog.querySelector('form').reset();
      const active=dialog.querySelector('[data-country][aria-current=true]');
      if(active)showCountry(active);
      picker.open=false;
      search.value='';rows.forEach(row=>row.hidden=false);
      dialog.querySelector('.kl-region-empty').hidden=true;
      dialog.showModal();document.documentElement.classList.add('kl-region-open');
      picker.querySelector('summary').focus();
    });
    dialog.querySelector('[data-kl-region-close]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
    dialog.addEventListener('close',()=>{document.documentElement.classList.remove('kl-region-open');opener?.focus();});
    picker.addEventListener('toggle',()=>{if(picker.open)search.focus();});
    search.addEventListener('input',()=>{const term=normalize(search.value.trim());let count=0;rows.forEach(row=>{const b=row.querySelector('button');row.hidden=!normalize(b.dataset.label+' '+b.dataset.country).includes(term);if(!row.hidden)count++;});dialog.querySelector('.kl-region-empty').hidden=count>0;});
    picker.addEventListener('click',event=>{const button=event.target.closest('[data-country]');if(!button)return;dialog.querySelector('[name=country_code]').value=button.dataset.country;showCountry(button);picker.open=false;picker.querySelector('summary').focus();});
  })();
  } catch(e) { console.error(e); }
})();

})();
